<div class="max-w-3xl mx-auto p-4">
  <div class="mb-4">
    <input type="text" [(ngModel)]="term" (keydown.enter)="lookup()" class="w-full border px-4 py-2 rounded" [placeholder]="'dict.enterWord' | translate" />
  </div>

  <div class="flex flex-wrap gap-4 mb-4">
    <label *ngFor="let store of stores" class="flex items-center space-x-2">
      <input type="checkbox" [checked]="selectedStores.has(store.title)" (change)="toggleStore(store.title)" />
      <span>{{ store.title }}</span>
    </label>
  </div>

  <button class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors" (click)="lookup()">{{ 'dict.lookup' | translate }}</button>

  <div *ngIf="loading" class="mt-4 text-gray-500">{{ 'dict.loading' | translate }}</div>

  <!-- No results found message -->
  <div *ngIf="noResultsFound && !loading && term" class="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
    <div class="flex items-center">
      <svg class="w-5 h-5 text-yellow-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
      </svg>
      <span class="text-yellow-800 font-medium">{{ 'dict.noWordFound' | translate }}</span>
    </div>
    <p class="text-yellow-700 text-sm mt-1">{{ 'dict.notFoundMsg' | translate: { term: term } }}</p>
  </div>

  <div class="mt-6 space-y-4">
    <div *ngFor="let def of results; trackBy: trackByDef" class="definition-card border p-4 rounded shadow bg-white">
      <div class="flex items-center justify-between mb-3">
        <div class="font-bold text-lg">{{ def.term }}</div>
        <span class="source-badge" [ngClass]="def.source">{{ def.source }}</span>
      </div>
      
      <!-- Regular definitions -->
      <div *ngIf="!isEtymology(def)" class="mt-2 prose prose-sm max-w-none">
        <div [innerHTML]="sanitizeHtml(def.html || def.definition)" class="leading-relaxed"></div>
      </div>
      
      <!-- Etymology content with special formatting -->
      <div *ngIf="isEtymology(def)" class="mt-2">
        <div class="text-sm text-gray-600 mb-2 font-semibold">{{ 'dict.etymology' | translate }}</div>
        <div class="etymology-content whitespace-pre-line text-sm leading-relaxed bg-gray-50 p-3 rounded border-l-4 border-blue-500">
          {{ getDisplayContent(def) }}
        </div>
      </div>
    </div>
  </div>
</div>
